import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

/**
 * Exporta o nó DOM do grid do mapa de vendas como PDF A4 landscape.
 *
 * @param {HTMLElement} gridNode - Elemento DOM a ser capturado (ref.current)
 * @param {string} companyName  - Nome da empresa (exibido acima do título)
 * @param {string} projectName  - Nome do projeto
 */
export async function exportSalesMapPDF(gridNode, companyName, projectName) {
    if (!gridNode) return;

    // Renderiza o grid como canvas de alta resolução
    const canvas = await html2canvas(gridNode, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#f0f2f5',
        logging: false,
    });

    // Dimensões A4 landscape em mm
    const pageW = 297;
    const pageH = 210;
    const margin = 8;

    // Espaço reservado para o bloco de título
    const companyLineH = companyName ? 5 : 0;  // mm para linha da empresa
    const titleLineH = 7;                        // mm para linha do projeto
    const titleGap = 3;                          // mm entre título e mapa
    const titleH = companyLineH + titleLineH + titleGap;

    const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

    // ── Título ────────────────────────────────────────────────
    let cursorY = margin;

    if (companyName) {
        pdf.setFontSize(8);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(140, 140, 140);
        pdf.text(companyName, pageW / 2, cursorY, { align: 'center' });
        cursorY += companyLineH;
    }

    pdf.setFontSize(11);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(30, 37, 53);
    pdf.text(
        `Mapa de Vendas${projectName ? ' — ' + projectName : ''}`,
        pageW / 2,
        cursorY,
        { align: 'center' }
    );

    // ── Imagem do mapa ────────────────────────────────────────
    const imgData = canvas.toDataURL('image/jpeg', 0.95);
    const availW = pageW - margin * 2;
    const availH = pageH - margin - titleH;

    // Escala proporcional para caber na área disponível
    const imgAspect = canvas.width / canvas.height;
    let imgW = availW;
    let imgH = imgW / imgAspect;
    if (imgH > availH) {
        imgH = availH;
        imgW = imgH * imgAspect;
    }

    const imgX = margin + (availW - imgW) / 2;
    const imgY = margin + titleH;
    pdf.addImage(imgData, 'JPEG', imgX, imgY, imgW, imgH);

    // Salva o arquivo com nome sanitizado
    const safeName = projectName
        ? '-' + projectName.replace(/\s+/g, '-').toLowerCase()
        : '';
    pdf.save(`mapa-vendas${safeName}.pdf`);
}
